import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";

import { MatDialog } from "@angular/material";
import { IRole } from "src/app/interfaces/role";
import { SoundEnum } from "src/app/enums/sound.enum";
import { TranslateService } from "@ngstack/translate";
import { IConfirm } from "src/app/interfaces/confirm";
import { IRoleGroup } from "src/app/interfaces/role-group";
import { RoleEntryComponent } from "../role-entry/role-entry.component";
import { SnackBarService } from "src/app/services/common/snackBar.service";
import { RoleService } from "src/app/services/http/business/role/role.service";
import { ConfirmComponent } from "./../../../../components/confirm/confirm.component";
import { GroupRoleService } from "src/app/services/http/business/groupRole/group-role.service";
import { ErrorsService } from "src/app/services/common/errors.service";

@Component({
  selector: "app-role-detail",
  templateUrl: "./role-detail.component.html",
  styleUrls: ["./role-detail.component.css"] //,
})
export class RoleDetailComponent implements OnInit {
  @Input() roleDetail: IRole;
  @Input() selectList: IRole[];
  @Input() groupList: any;
  @Output() showDetail = new EventEmitter();

  constructor(
    private dialog: MatDialog,
    private roleService: RoleService,
    private snackBar: SnackBarService,
    private errorService: ErrorsService,
    public translate: TranslateService,
    private groupRoleService: GroupRoleService
  ) {
  }

  ngOnInit() {

  }

  addChild() {
    this.dialog
      .open(RoleEntryComponent, {
        data: this.roleDetail.Id
      })
      .afterClosed()
      .subscribe(
        () => {
          this.roleService.fire();
        },
        () => {
          this.snackBar.OpenSnackBar(
            this.translate.get("error.transaction"),
            "ok",
            5000,
            SoundEnum.beep
          );
        }
      );
  }

  editRole() {
    this.dialog
      .open(RoleEntryComponent, {
        data: this.roleDetail
      })
      .afterClosed()
      .subscribe(
        res => {
          this.roleDetail.Title = res.Title;
          this.roleDetail.Code = res.Code;
          this.roleService.fire();
        },
        () => {
          this.snackBar.OpenSnackBar(
            this.translate.get("error.transaction"),
            "ok",
            5000,
            SoundEnum.beep
          );
        }
      );
  }
  delete() {
    let confirm: IConfirm = {
      accept: true,
      message: this.translate.get("confirm.delete", {
        name: this.translate.get("label.group") + " " + this.roleDetail.Title
      }),
      alert:null,
      yesLabel: this.translate.get("label.yes"),
      noLabel: this.translate.get("label.no")
    };
    this.dialog
      .open(ConfirmComponent, {
        width: "250px",
        data: confirm
      })
      .afterClosed()
      .subscribe(res => {
        if (res)
          this.roleService.delete(this.roleDetail).subscribe(
            () => {
              this.roleService.fire();
              this.roleService.hide();
            },
            err => {
              this.errorService.recordHasBennUsed(err);
            }
          );
      });
  }

  submit(roleId, selectList) {
    let idList = [];
    for (let item of selectList) {
      idList.push(item.Id);
    }
    let data: IRoleGroup = {
      RoleId: roleId,
      ListGroupId: idList
    };
    this.groupRoleService.save(data).subscribe(() => {
      this.snackBar.OpenSnackBar(
        this.translate.get("success.registration"),
        "ok",
        5000,
        SoundEnum.beep
      );
    });
  }
}
